import styled from 'styled-components'

type TypeButton ={
    color?: string,
    hover?: boolean,
    size?: string | null
}
export const Container = styled.div<TypeButton> `
    background: transparent;
    border: none;
    ${props => props.size === null ? '' : `& svg { width:${props.size}}`}
    ${props => props.hover ? 
        `& > svg path{
            transition: fill .3s ease;
        }
        &:hover, &:active{
            & > svg path{
                fill: ${props.color};
            }
        }`: `& > svg path{
            fill: ${props.color};
        }`}`
